import React from "react";

const VARIANTS = {
  coin: {
    src: "/assets/currency-coin.png",
    alt: "flying coins",
  },
  ruby: {
    src: "/assets/currency-ruby.png",
    alt: "flying rubies",
  },
} as const;

type Variant = keyof typeof VARIANTS;

const PARTICLE_CONFIG: Array<{
  size: 30 | 18 | 12;
  direction: string;
  position: "center" | "corner";
  delay?: string;
}> = [
  // Large (30px) – no delay
  { size: 30, direction: "up", position: "center" },
  { size: 30, direction: "down", position: "center" },
  { size: 30, direction: "left", position: "corner" },
  { size: 30, direction: "right", position: "corner" },
  { size: 30, direction: "up-left", position: "corner" },
  { size: 30, direction: "up-right", position: "corner" },
  { size: 30, direction: "down-left", position: "corner" },
  { size: 30, direction: "down-right", position: "corner" },
  // Medium (18px)
  { size: 18, direction: "up", position: "center", delay: "0.1s" },
  { size: 18, direction: "down", position: "center", delay: "0.2s" },
  { size: 18, direction: "left", position: "corner", delay: "0.15s" },
  { size: 18, direction: "right", position: "corner", delay: "0.25s" },
  { size: 18, direction: "up-left", position: "corner", delay: "0.1s" },
  { size: 18, direction: "up-right", position: "corner", delay: "0.2s" },
  { size: 18, direction: "down-left", position: "corner", delay: "0.15s" },
  { size: 18, direction: "down-right", position: "corner", delay: "0.25s" },
  // Small (12px)
  { size: 12, direction: "up", position: "center", delay: "0.3s" },
  { size: 12, direction: "down", position: "center", delay: "0.4s" },
  { size: 12, direction: "left", position: "corner", delay: "0.35s" },
  { size: 12, direction: "right", position: "corner", delay: "0.45s" },
];

interface FlyingCurrencyProps {
  variant: Variant;
  isAnimating: boolean;
}

export default function FlyingCurrency({ variant, isAnimating }: FlyingCurrencyProps) {
  if (!isAnimating) return null;

  const { src, alt } = VARIANTS[variant];
  const baseStyle: React.CSSProperties = { transformStyle: "preserve-3d" };

  return (
    <div className="relative" style={{ perspective: "1000px" }}>
      {PARTICLE_CONFIG.map(({ size, direction, position, delay }, index) => (
        <img
          key={`${size}-${direction}-${index}`}
          alt={alt}
          className={`flying-coins-${direction} absolute ${
            position === "center" ? "top-0 left-1/2 -translate-x-1/2" : "top-0 left-0"
          }`}
          style={{
            ...baseStyle,
            width: size,
            height: size,
            ...(delay && { animationDelay: delay }),
          }}
          src={src}
        />
      ))}
    </div>
  );
}
